import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import FetchMoreWrapper from 'js/components/FetchMoreWrapper'
import { Container } from 'js/components/Grid'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'

import Card from './components/Card'

const List = () => {
    const { data } = useQuery(POLLS_WRAPPER)

    const { viewer } = data || {}
    const { t } = useTranslation()

    useWindowScrollPosition('polls')

    return (
        <Fragment>
            <PageHeader
                title={t('entity-poll.title')}
                canCreate={viewer?.canWriteToContainer}
                createLink="/polls/add"
                createLabel={t('entity-poll.create')}
            />
            <Section>
                <Container size="tiny">
                    <FetchMoreWrapper
                        childComponent={Card}
                        subtype="poll"
                        offset={0}
                        limit={20}
                        query={POLLS_LIST}
                    />
                </Container>
            </Section>
        </Fragment>
    )
}

export const POLLS_LIST = gql`
    query PollsList($offset: Int!, $limit: Int!, $subtype: String!) {
        entities(offset: $offset, limit: $limit, subtype: $subtype) {
            total
            edges {
                guid
                ... on Poll {
                    guid
                    title
                    url
                }
            }
        }
    }
`

export const POLLS_WRAPPER = gql`
    query PollsWrapper {
        viewer {
            guid
            loggedIn
            canWriteToContainer(subtype: "poll")
        }
    }
`

export default List
